import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useGuardrailCompositionsApi } from "../../../../../http/border/useGuardrailCompositions";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { BORDER } from "../../AdminSystemSettings";
import GuardrailCompositionForm from "./GuardrailCompositionForm";

const GuardrailComposition: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { guardrailCompositionId } = useParams<{ guardrailCompositionId: string }>();
  const guardrailCompositionsApi = useGuardrailCompositionsApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = guardrailCompositionsApi.getAdminGuardrailComposition(
    guardrailCompositionId!,
    aborter.current.signal,
  );

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: BORDER },
    {
      url: `/admin/systems/${systemId}/settings?tab=10`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.guardrailCompositions.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    guardrailCompositionId && trigger();
  }, [guardrailCompositionId]);

  return (
    <>
      <Header
        title={`${i18n.translation.guardrailCompositions.singular}: ${data?.name ?? ""}`}
        error={error}
        path={path}
      />
      <FlexContent padding direction="row">
        <GuardrailCompositionForm guardrailComposition={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default GuardrailComposition;
